import { Path } from 'react-hook-form';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { LogotiposForm } from '@/features/logos/components/LogotiposForm';
import { useLogoFormPicker } from '@/features/logos/hooks/use-logo-form-picker';
import { TLogosForm } from '@/features/logos/types';
import { useSegmentPresences } from '@/hooks/use-segment-presences';
import { getAbsoluteDateFromPlayerTime } from '@/utils/hh-mm-ss-into-number';

import { useTableLabelsOnMount } from '../context/BroadcastScheduleProvider';
import { TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm } from '../types';

export function BroadcastScheduleProgramBodySegmentToolkitLogotiposForm() {
  const { activeSegment, playerVideoCurrentTime, handleDateTimeSegment, logoData, formBox } =
    useBroadcastScheduleProgram();
  const {
    form,
    isCreatingLogos,
    drawerLogo,
    handleClickExit,
    handleSubmit,
    handleSubmitLogo,
    renderAdditionalButtons,
  } = useSegmentPresences();

  const labelsIn = useTableLabelsOnMount();
  const { picker, selectedLogo, selectCreatedLogo } = useLogoFormPicker({
    form,
    fallbackLabel: logoData?.entity_label,
    labelsIn,
    isActive: formBox === 'logo',
  });

  const setIfEmpty = (
    name: Path<TBroadcastScheduleProgramBodySegmentToolkitLogotiposForm>,
    value: string | Date
  ) => {
    if (!form.getValues(name)) {
      form.setValue(name, value);
    }
  };

  const handleClickAdd = () => {
    if (!activeSegment?.start_datetime) return;
    const newDateTime = getAbsoluteDateFromPlayerTime(
      activeSegment.start_datetime,
      playerVideoCurrentTime
    );

    setIfEmpty('start_datetime', newDateTime);
    setIfEmpty('end_datetime', newDateTime);
  };

  const handleCreateLogo = async (data: TLogosForm) => {
    const logo = await handleSubmitLogo(data);
    selectCreatedLogo(logo);
    return logo;
  };

  return (
    <LogotiposForm
      form={form}
      logoPicker={picker}
      selectedLogo={selectedLogo}
      isCreatingLogos={isCreatingLogos}
      drawerLogo={drawerLogo}
      handleClickAdd={handleClickAdd}
      handleClickExit={handleClickExit}
      handleSubmit={handleSubmit}
      handleSubmitLogo={handleCreateLogo}
      renderAdditionalButtons={renderAdditionalButtons}
      onClickTooltipDate={name => handleDateTimeSegment(form, name)}
    />
  );
}
